import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";

import axios from "connection";

import getOpco from "utils/getOpco";

import { API_URL, PPE_V1_PATH, PPE_V2_PATH } from "config";
import { isFeatureActive } from "utils/getFeature";
import isCableURL from "utils/isCableURL";
import { setOffersLoaded } from "state/offers-slice";
import { setModal } from "state/config-slice";

const PATH = isFeatureActive("PPE 1.0 Backend") ? JSON.parse(PPE_V1_PATH)["1.1"] : PPE_V2_PATH;

const customBaseQuery =
  ({ baseUrl }: { baseUrl: string } = { baseUrl: "" }): BaseQueryFn =>
  async () => {
    try {
      const result = await axios.get(baseUrl, {
        headers: {
          "page-source": window.location.pathname,
        },
      });

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const offersApi = createApi({
  reducerPath: "offersApi",
  baseQuery: customBaseQuery({
    baseUrl: `${API_URL}${PATH}/offers?facets=amount&opco=${getOpco()}&marketplace=true&isCable=${isCableURL()}`,
  }),
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: () => true,
      onQueryStarted: async (_, api) => {
        const { dispatch, queryFulfilled } = api;

        try {
          const { data } = await queryFulfilled;
          if (data) {
            dispatch(setOffersLoaded(true));
          }
        } catch (err) {
          dispatch(
            setModal({
              showModal: true,
              errorModal: true,
            }),
          );
        }
      },
    }),
  }),
});

export const { useGetOffersQuery } = offersApi;
